import { render, staticRenderFns } from "./AddGenreForm.vue?vue&type=template&id=7b2e5b0a&scoped=true&"
import script from "./AddGenreForm.vue?vue&type=script&lang=js&"
export * from "./AddGenreForm.vue?vue&type=script&lang=js&"
import style0 from "./AddGenreForm.vue?vue&type=style&index=0&id=7b2e5b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2e5b0a",
  null
  
)

export default component.exports